export function mergeFormInitialData(defaultValue = {}, storeData = {}) {
  return { ...defaultValue, ...storeData }
}
